import React from "react";
import {
  AppBar,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Tab,
  Tabs,
} from "@material-ui/core";
import Base from "../../../base/views/base";
import PhysicalInventoryLandingPageWithLotNo from "./PhysicalInventoryLandingPageWithLotNo";
import PhysicalInventoryLandingPageWithoutLotNo from "./PhysicalInventoryLandingPageWithoutLotNo";
import { TabPanel } from "../../../Analytics/Dashboard/views/AnalyticsDashboard";
import { useCatalogLastModifiedDate } from "../helper/hooks";
import { useState } from "react";
import { format } from "date-fns";
import { getSessionData } from "../../../base/helper/baseHelper";
import { useEffect } from "react";
import history from "../../../../../history";
import { PRIMARY_COLOR } from "../../../../constants/baseConstants";

const PhysicalInventoryLandingPage = (props) => {
  const [value, setValue] = React.useState(0);
  const [storeId, setStoreId] = useState("");
  const { date, isLoading } = useCatalogLastModifiedDate(storeId);
  const [showLastPriceModifiedPopup, setShowLastPriceModifiedPopup] = useState(
    null
  );
  const [lastPriceModifiedSeen, setLastPriceModifiedSeen] = useState(false);

  function a11yProps(index) {
    return {
      id: `scrollable-force-tab-${index}`,
      "aria-controls": `scrollable-force-tabpanel-${index}`,
    };
  }

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    const store = JSON.parse(getSessionData({ key: "store" }));
    setStoreId(store.storeid);
  }, []);

  const goToCatalogUpload = () => {
    history.push("/uploads?tab=upload_catalog");
  };

  const openLastPriceModifiedPopup =
    showLastPriceModifiedPopup === value && // on same tab as the tab which called for open
    isLoading === false &&
    date !== null && // null is initial value, means date not fetched yet
    lastPriceModifiedSeen === false;

  return (
    <div style={{ display: "flex" }}>
      <Base showBaseMenu={true} title="Physical Inventory">
        <AppBar style={{ marginTop: 50 }} position="static" color="transparent">
          <Tabs
            value={value}
            onChange={handleChange}
            indicatorColor="primary"
            textColor="primary"
            aria-label="scrollable force tabs example"
            centered
          >
            <Tab label="With Lot No." {...a11yProps(0)} />
            <Tab label="Without Lot No." {...a11yProps(1)} />
          </Tabs>
        </AppBar>
        <TabPanel value={value} index={0}>
          <PhysicalInventoryLandingPageWithLotNo
            setShowLastPriceModifiedPopup={setShowLastPriceModifiedPopup}
          />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <PhysicalInventoryLandingPageWithoutLotNo
            setShowLastPriceModifiedPopup={setShowLastPriceModifiedPopup}
          />
        </TabPanel>
      </Base>
      <Dialog
        open={openLastPriceModifiedPopup}
        onClose={() => setShowLastPriceModifiedPopup(false)}
      >
        <DialogTitle>Price Catalog</DialogTitle>
        <DialogContent>
          {date
            ? `Price catalog last updated on ${format(
                date,
                "dd-MM-yyyy"
              )}. Do you want to upload a new price list?`
            : "Price catalog was not found. Do you want to continue?"}
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={goToCatalogUpload}>
            Upload
          </Button>
          <Button
            variant="contained"
            style={{ backgroundColor: PRIMARY_COLOR, color: "white" }}
            onClick={() => {
              setShowLastPriceModifiedPopup(null);
              setLastPriceModifiedSeen(true);
            }}
          >
            Continue
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default PhysicalInventoryLandingPage;
